import { Step, StepValidationState } from "../../../../../interfaces/step";
import { Stepper } from "../../../../../interfaces/stepper";
import { RegistrationNumberSearchReviewComponent } from "projects/reg-hub-client/src/app/orders/registration-number-search-review/registration-number-search-review.component";
import { RegistrationNumberSearchCriteriaComponent } from "projects/reg-hub-client/src/app/orders/registration-number-search-criteria/registration-number-search-criteria.component";
import { SearchStepper, eCriteriaVariation } from "../search-stepper";

export class NURegistrationNumberSearchStepper extends SearchStepper {

    constructor() {
        super()
        this.configuration = [
        ];

        this.steps = [
            { title: "Search Criteria", content: RegistrationNumberSearchCriteriaComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: RegistrationNumberSearchReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}